import { createContext, useState } from "react";

export const AuthContext = createContext({
  user: null,
  setUser: () => {},
  clearAuth: () => {},
});


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const clearAuth = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, clearAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
